var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_rotate-left",
    "data-name": "vuesax/bold/rotate-left",
    transform: "translate(-236 -316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rotate-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.19,0H5.81C2.17,0,0,2.17,0,5.81v8.37C0,17.83,2.17,20,5.81,20h8.37c3.64,0,5.81-2.17,5.81-5.81V5.81C20,2.17,17.83,0,14.19,0Z",
    transform: "translate(238 318)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(260 340) rotate(180)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "noun-turn-off-3815112",
    d: "M144.543,48.235V44.179a.64.64,0,1,1,1.281,0v4.056a.64.64,0,1,1-1.281,0Zm4.577-1.484h0a.623.623,0,0,0-.505-.258.688.688,0,0,0-.216.035.631.631,0,0,0-.44.611.655.655,0,0,0,.144.391,3.643,3.643,0,0,1-2.185,5.756,3.743,3.743,0,0,1-.727.071,3.65,3.65,0,0,1-3.652-3.645,3.59,3.59,0,0,1,.742-2.2.584.584,0,0,0,.129-.349.652.652,0,0,0-.453-.623.687.687,0,0,0-.216-.035.611.611,0,0,0-.5.252,4.872,4.872,0,0,0-.985,3.086A4.991,4.991,0,0,0,145,54.635c.06,0,.12,0,.181,0a4.925,4.925,0,0,0,3.935-7.888Z",
    transform: "translate(102.743 278.467)",
    fill: "#fff"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.6f701aa2d60c9f50bb76180c359bafb7.svg";
export { ForwardRef as ReactComponent };